import { getObjectByKeys } from "helpers/commonHelpers";
import { AttachmentBucket } from "types/Common";

import { BucketFileEntry, OtherFileState } from "@RequestFormV2/sections/Provider/hooks/attachmentTypes";

export function isOtherBucketFile(entry: BucketFileEntry, otherBucket: AttachmentBucket): boolean {
  if (entry.id === otherBucket.id) return true;
  return entry.bucket_name?.toLowerCase() === otherBucket.bucket_name?.toLowerCase();
}

export function bucketEntryToFileState(entry: BucketFileEntry): OtherFileState {
  return {
    id: entry.id,
    file: entry.file,
    filename: entry.filename,
    name: entry.filename,
    url: entry.url,
    bucket_name: entry.bucket_name,
    progress: 0,
    error: false,
    errorMessage: "",
  };
}

export function hydrateOtherFilesFromForm(
  otherBucket: AttachmentBucket | undefined,
  bucketAttachments: BucketFileEntry[],
  otherAttachments: OtherFileState[] | undefined,
): Record<string | number, OtherFileState> {
  if (otherBucket) {
    const otherBucketFiles = bucketAttachments.filter((entry) => isOtherBucketFile(entry, otherBucket));
    if (otherBucketFiles.length) {
      return getObjectByKeys(otherBucketFiles.map(bucketEntryToFileState), "file") as Record<string | number, OtherFileState>;
    }
    return {};
  }

  if (otherAttachments?.length) {
    return getObjectByKeys(otherAttachments) as Record<string | number, OtherFileState>;
  }

  return {};
}

export function migrateOtherAttachmentsToBucket(
  otherBucket: AttachmentBucket,
  bucketAttachments: BucketFileEntry[],
  otherAttachments: OtherFileState[],
): BucketFileEntry[] {
  return otherAttachments
    .map((otherAttachment) => ({
      bucket_name: otherBucket.bucket_name,
      id: otherBucket.id,
      url: otherAttachment.url,
      file: (otherAttachment.reference_number ?? otherAttachment.file) as string,
      filename: otherAttachment.filename ?? otherAttachment.name,
    }))
    .filter(
      (entry) =>
        entry.file &&
        entry.filename &&
        !bucketAttachments.some((bucketAttachment) => bucketAttachment.filename === entry.filename),
    );
}
